import { useState } from 'react'
import { propTypes } from '../../helpers'
import { Container } from 'react-bootstrap'
import {
  AffiliationForm,
  ContentPanel,
  DropdownAccordion,
  Toolbar
} from '../../components'
import { useApplicationName } from '../../store'
import styled from 'styled-components'
import { UsersList, UserType } from './UsersList'
import {
  useAdminCategories,
  useAffiliation,
  useSaveAffiliationMutation
} from '../../hooks'
import { Helmet } from 'react-helmet-async'

const NEW_USERS = { id: 1, name: 'New User Requests' }
const EXISTING_USERS = { id: 2, name: 'Manage Users' }
const ALL_USERS = { id: 3, name: 'Search Among All Users' }
const MANAGE_CATEGORIES = { id: 4, name: 'Edit Group Categories' }
const adminOptions = [NEW_USERS, EXISTING_USERS, ALL_USERS, MANAGE_CATEGORIES]

const Title = styled.div`
  font-size: 28px;
  padding-bottom: 0.5rem;
`

const AdminPage = ({ category }) => {
  const [userType, setUserType] = useState(UserType.New)
  const [selected, setSelected] = useState(adminOptions[0])
  const applicationName = useApplicationName()
  const { affiliation } = useAffiliation()
  const { categories } = useAdminCategories()
  const { mutate: saveAffiliation } = useSaveAffiliationMutation()

  const handleOptionSelect = (option) => {
    switch (option) {
      case NEW_USERS:
        setUserType(UserType.New)
        break
      case EXISTING_USERS:
        setUserType(UserType.Existing)
        break
      case ALL_USERS:
        setUserType(UserType.All)
        break
      default:
    }
    setSelected(option)
  }

  const handleSubmit = (data) => saveAffiliation({ data })

  return (
    <Container className='resizing-container'>
      <Helmet>
        <title>
          {affiliation.name} {category.name} - {applicationName}
        </title>
      </Helmet>
      <Toolbar title={`${affiliation.name} ${category.name}`}>
        <DropdownAccordion
          id='adminSelect'
          title='Select'
          options={adminOptions}
          selectedOption={selected}
          onOptionSelect={handleOptionSelect}
          variant='link'
          menuAlign={{ sm: 'left' }}
        />
      </Toolbar>
      <ContentPanel>
        <Title>{selected.name}</Title>
        {selected === MANAGE_CATEGORIES ? (
          <AffiliationForm
            formData={{ ...affiliation, categories }}
            onSubmit={handleSubmit}
          />
        ) : (
          <UsersList userType={userType} />
        )}
      </ContentPanel>
    </Container>
  )
}

AdminPage.propTypes = { category: propTypes.categoryPropType }

export { AdminPage }
